import { useDocumentTitle } from "./index";

function Page({ title, children }) {
  useDocumentTitle(title);
  return children;
}

export default Page;
